import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { I18nextProvider } from 'react-i18next';
import { theme } from '@/app/theme';
import { queryClient } from '@/app/queryClient';
import i18n from '@/app/i18n';
import { router } from '@/app/router';
import { Loader } from '@/components/Loader';
import { DialogHost } from '@/components/dialogs/useDialog';
import '@/app/swal.css';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root not found');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <I18nextProvider i18n={i18n}>
          <QueryClientProvider client={queryClient}>
            <Loader />
            <DialogHost />
            <RouterProvider router={router} />
            <ReactQueryDevtools initialIsOpen={false} />
          </QueryClientProvider>
        </I18nextProvider>
      </LocalizationProvider>
    </ThemeProvider>
  </React.StrictMode>,
);
